import { render, staticRenderFns } from "./typing-indicator.vue?vue&type=template&id=505ddc14&scoped=true&"
import script from "./typing-indicator.vue?vue&type=script&lang=js&"
export * from "./typing-indicator.vue?vue&type=script&lang=js&"
import style0 from "./typing-indicator.vue?vue&type=style&index=0&id=505ddc14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ddc14",
  null
  
)

export default component.exports